import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { BillingCycleTypes } from '../../models/domain/invoice';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ssApiService } from '../../services/ss-api.service';
import { BaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { CreditCardArray } from '../../models/domain/credit.card';
import { SelectItem } from 'primeng/primeng';
import { MemberDashboardLicenseResponse } from '../../models/ss-api/responses/member.dashboard.license.response';
import { MemberDashboard } from '../../models/ss-api/responses/member.dashboard.response';
import { ReactivateSimulationRequestv2 } from '../../models/ss-api/requests/reactivate.simulation.request.v2';
import { ReactivateLicenseRequestv2 } from '../../models/ss-api/requests/reactivate.license.request.v2';
import { LicenseReactivateSimulationResponsev2 } from '../../models/ss-api/responses/license.reactivate.simulation.response.v2';
import { UserRolesService } from '../../services/user.roles.service';
import { Router } from '@angular/router';

export interface IKeyReactivateDevDialogModel {
    CDKey: string;
    MemberID: number;
    LicenseID: number;
    License: MemberDashboardLicenseResponse;
    DashboardData: MemberDashboard;
}

@Component({
    selector: 'key-reactivate-dialog-dev',
    styleUrls: ['./key.reactivate.dev.dialog.css'],
    templateUrl: './key.reactivate.dev.dialog.html'
})
export class KeyReactivateDevDialog extends DialogComponent<IKeyReactivateDevDialogModel, boolean> implements IKeyReactivateDevDialogModel, OnInit {

    DashboardData: MemberDashboard;

    MemberID: number;
    IsBusy: boolean = false;

    License: MemberDashboardLicenseResponse;

    private CCData: CreditCardArray;
    creditCards: SelectItem[] = [];
    selectedCreditCard: number;
    selectedCreditCardID: number;

    billingCycles: SelectItem[];
    selectedBillingCycle: SelectItem;
    selectedCycleType: BillingCycleTypes = BillingCycleTypes.Monthly;

    products: SelectItem[];
    selectedProduct: number;

    AssignmentOptions: SelectItem[];
    KeyAssignment: number;

    IncludeYard: boolean = false;
    DesignerFieldsHidden: boolean = true;
    DesignerName: string;
    DesignerEmail: string;

    FreeReactivation: boolean = false;

    CDKey: string;
    LicenseID: number;

    IsInCycle: boolean = false;

    NewMemberEmail: string;

    simulationResponse: LicenseReactivateSimulationResponsev2 = new LicenseReactivateSimulationResponsev2();

    ProductPrice: number = 0;
    SetupPrice: number = 0;
    TotalPrice: number = 0;
    Credit: number = 0;
    PayableTotal: number = 0;
    YardPrice: number;

    constructor(private api: ssApiService, dialogService: DialogService, private sweetAlertService: SweetAlertService, public roles: UserRolesService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.setUpCreditCards();
        this.setUpBillingCycles();
        this.setUpProducts();
        this.setupAssignmentOptions();
        // this.License.BillingCycle

        this.selectedCycleType = this.License.BillingCycle;

        if (this.License.Yard || this.License.YardCancelled) {
            this.IncludeYard = true;
        }
    }

    SimulatePricing() {
        this.IsBusy = true;

        if (this.selectedProduct != 3) {
            this.IncludeYard = false;
        }

        let request: ReactivateSimulationRequestv2 = {
            LicenseKey: this.CDKey,
            NewProductID: this.selectedProduct,
            IncludeYARD: this.IncludeYard,
            BillingCycle: this.selectedCycleType
        }

        this.api.LicenseReActivateSimulationv2(request).subscribe(response => {
            this.IsBusy = false;
            if (response.Result) {
                this.simulationResponse = response.Data;

                if (this.simulationResponse.ProductPrice <= 0) {
                    this.IsInCycle = true;
                }

                // this.ProductPrice = response.Data.ProductPrice;
                // this.SetupPrice = response.Data.SetupPrice;
                // this.TotalPrice = response.Data.TotalPrice;
                // this.Credit = response.Data.Credit;
                // this.PayableTotal = response.Data.Total;
                // this.YardPrice = response.Data.YARDPrice;

                if (this.PayableTotal < 0)
                    this.PayableTotal = 0;

            } else {
                this.sweetAlertService.swal({
                    type: 'error',
                    title: 'Error',
                    text: response.Message
                }).then(() => { this.close() }, () => { this.close() })
            }


        }, error => {

        });

    }

    async setUpCreditCards() {

        this.IsBusy = true;

        let newCard: SelectItem = {
            label: 'Free Reactivation - No Card', value: 0
        };
        this.creditCards.push(newCard);

        await this.api.getUsableCCards(this.MemberID).subscribe(
            (result: BaseResponse<CreditCardArray>) => {
                this.CCData = result.Data;

                // Sort the cards so default is always the first option
                let sortedCreditCards = this.CCData.sort(function (a, b) {
                    return (a.IsDefault === b.IsDefault) ? 0 : a.IsDefault ? -1 : 1;
                })

                sortedCreditCards.forEach(e => {

                    if (!e.IsActive || e.IsDeleted || (!e.IsDefault && e.Status == 'Expired'))
                        return;

                    let newCard: SelectItem = {
                        label: e.FirstName + ' ' + e.LastName + ' - XXXX XXXX XXXX ' + e.LastFour, value: e.ID
                    };
                    this.creditCards.push(newCard);
                });

                if (this.creditCards.length > 1) {
                    this.selectedCreditCard = this.creditCards[1].value;
                }

                this.IsBusy = false;
            },

            (error: any) => {
                this.IsBusy = false;
            }

        );



    }

    setUpBillingCycles() {
        this.billingCycles = [
            { label: 'Monthly', value: 1 },
            { label: 'Yearly', value: 2 }
        ]
        this.selectedBillingCycle = this.billingCycles[0];
    }

    setupAssignmentOptions() {
        this.AssignmentOptions = [
            { label: 'Keep Assigned', value: 0 },
            { label: 'Assign to Member', value: 1 },
            { label: 'Assign to Designer', value: 2 }
        ]

        this.KeyAssignment = this.AssignmentOptions[0].value;
    }

    setUpProducts() {
        let products = [
            { label: 'VIP3D', value: 3 },
            { label: 'Pool Studio', value: 2 },
            { label: 'VizTerra', value: 1 }
        ]

        this.products = products;

        if (this.License.Product === 'VIP3D') {
            this.selectedProduct = 3;
        }

        if (this.License.Product === 'Pool Studio') {
            this.selectedProduct = 2;
        }

        if (this.License.Product === 'VizTerra') {
            this.selectedProduct = 1;
        }

        if (!this.selectedProduct) {
            this.selectedProduct = products[0].value;
        }

        this.SimulatePricing();
    }

    BillingCycleChanged(e) {
        this.selectedCycleType = e.value;

        this.SimulatePricing();
    }

    ProductChanged(e) {
        this.SimulatePricing();
    }

    AssignmentChanged(e) {
        this.KeyAssignment = e.value;
    }

    onIncludeYard() {
        if (this.selectedProduct == 3) {
            this.IncludeYard = !this.IncludeYard;
        } else {
            this.IncludeYard = false;
        }

        this.SimulatePricing();
    }

    async confirm() {
        this.IsBusy = true;

        let request = new ReactivateLicenseRequestv2;
        request.CreditCardID = this.selectedCreditCard;
        request.LicenseID = this.LicenseID;
        request.FreeReactivation = this.FreeReactivation;
        request.BillingCycle = this.selectedCycleType;
        request.IncludeYARD = this.IncludeYard;
        request.designerEmail = this.DesignerEmail;
        request.designerName = this.DesignerName;
        request.NewProductID = this.selectedProduct;

        switch (this.KeyAssignment) {
            case 0:
                request.keepAssigned = true;
                break;
            case 1:
                request.assignToMember = true;
                break;
            case 2:
                request.assignToMember = false;
                break;
        }

        if (request.CreditCardID == 0)
            request.FreeReactivation = true;

        await this.sweetAlertService.swal(
            {
                title: 'Reactivate Key?',
                text: 'Are you sure you want to reactivate this License Key?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.LicenseReActivatev2(request).toPromise();
                }
            })
            .then(response => {
                this.result = true;
                this.close();
                this.sweetAlertService.swal(
                    {
                        title: 'Success',
                        text: 'License Key Reactivated',
                        type: 'success',
                        showCancelButton: false,
                        showConfirmButton: false,
                        timer: 1500
                    })
                    .then((response: any) => {
                        this.IsBusy = false;
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            }, (dismiss) => {
                this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then((response: any) => {
                        this.result = false;
                        this.IsBusy = false;
                        this.close();
                    }, (dismiss) => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });

    }

}
